// ExportModal.jsx
import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useLanguage } from "../helpers/LanguageContext";

const rowStyle = {
  display: "flex",
  alignItems: "center",
  padding: "6px 8px",
  borderRadius: "6px",
  cursor: "pointer",
  transition: "background 0.15s ease"
};

const dividerStyle = {
  marginTop: "20px",
  marginBottom: "20px",
  opacity: 0.5
};

export default function ExportModal({
  show,
  onClose,
  exportMode,
  setExportMode,
  usedColors,
  selectedColorIds,
  setSelectedColorIds,
  usedTables,
  selectedTableIds,
  setSelectedTableIds,
  onConfirm
}) {
  const { t } = useLanguage();

  const toggleColor = (id) => {
    if (selectedColorIds.includes(id)) {
      setSelectedColorIds((p) => p.filter((x) => x !== id));
    } else {
      setSelectedColorIds((p) => [...p, id]);
    }
  };

  const toggleTable = (id) => {
    if (selectedTableIds.includes(id)) {
      setSelectedTableIds((p) => p.filter((x) => x !== id));
    } else {
      setSelectedTableIds((p) => [...p, id]);
    }
  };

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{t("exportTitle")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {[
            { value: "work", label: t("exportFullWork") },
            { value: "colors", label: t("exportColors") },
            { value: "tables", label: t("exportSpecificTables") }
          ].map((opt) => (
            <div
              key={opt.value}
              style={rowStyle}
              onClick={() => setExportMode(opt.value)}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#f5f5f5")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "transparent")
              }
            >
              <Form.Check
                type="radio"
                checked={exportMode === opt.value}
                readOnly
                label={opt.label}
              />
            </div>
          ))}
        </Form>

        <hr style={dividerStyle} />

        {exportMode === "colors" &&
          usedColors.map((c) => (
            <div
              key={c.colorId}
              style={rowStyle}
              onClick={() => toggleColor(c.colorId)}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#f5f5f5")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "transparent")
              }
            >
              <Form.Check
                type="checkbox"
                checked={selectedColorIds.includes(c.colorId)}
                readOnly
                label={t(c.name)}
              />
            </div>
          ))}

        {exportMode === "tables" &&
          usedTables.map((tb) => (
            <div
              key={tb.id}
              style={rowStyle}
              onClick={() => toggleTable(tb.id)}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "#f5f5f5")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "transparent")
              }
            >
              <Form.Check
                type="checkbox"
                checked={selectedTableIds.includes(tb.id)}
                readOnly
                label={tb.label}
              />
            </div>
          ))}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t("cancel")}
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          {t("exportBtn")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
